import { Modal } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import Styles from "./ImportProduct.module.css";
import cancelIcon from "../../../Assets/cross.png";
import {
  CreateInventoryService,
  ImportInventoryFileService,
} from "../../../Services/ApiServices";
import Loader from "../../../SharedComponents/Loader/Loader";
import { Button, Select, Upload } from "antd";
import { useState } from "react";
import downloadIcon from "../../../Assets/download_icon.png";

export default function ImportProduct(props) {
  const [ImporttedFile, setImporttedFile] = useState();
  const [IsLoading, setIsLoading] = useState(false);

  const [fileList, setFileList] = useState([]);

  const beforeUpload = (file) => {
    const isExcelOrCSV =
      // file.type ===
      //   "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      // file.type === "application/vnd.ms-excel" ||
      file.type === "text/csv";

    // Excel (.xls, .xlsx) or
    if (!isExcelOrCSV) {
      toast.error("Only CSV file is allowed!");
      return Upload.LIST_IGNORE; // Prevent upload
    }

    setImporttedFile(file);
    return false; // Prevent automatic upload (we handle manually)
  };

  const handleFileUpload = () => {
    if (!ImporttedFile) {
      toast.error("Please select a file before importing!");
      return;
    }

    // setIsLoading(true);
    const formData = new FormData();
    formData.append("file", ImporttedFile); // ✅ attach file

    ImportInventoryFileService(formData)
      .then((res) => {
        toast.success(res?.data?.msg || "File imported successfully!");
        props.onHide(false);
        setFileList([]);
        setImporttedFile(null);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.detail?.[0]?.msg || "Something went wrong!"
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  console.log(ImporttedFile, "ImporttedFile", fileList);

  return (
    <div className={Styles.parentContainer + " container-fluid"}>
      {IsLoading && <Loader isLoader={true} />}

      <div className="container">
        <Modal
          size="xs"
          show={props.isOpen}
          onHide={props.onHide}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Body>
            <div className={Styles.cancelImgParentContainer}>
              <div>
                <p className="fontBold">
                  Import <span className="orange">File</span>
                </p>
              </div>
              <div className={Styles.cancelImgContainer}>
                <img
                  onClick={props.onHide}
                  src={cancelIcon}
                  alt="cancel"
                  className={Styles.cancelImg}
                />
              </div>
            </div>

            <div style={{ padding: "10px 0" }}>
              <Upload
                beforeUpload={beforeUpload}
                showUploadList={{ showRemoveIcon: true }}
                maxCount={1}
                fileList={fileList}
                onChange={({ fileList }) => setFileList(fileList)}
                onRemove={() => {
                  setImporttedFile(null);
                  setFileList([]);
                }}
              >
                {/* Excel / */}
                <Button>Select File (CSV)</Button>
              </Upload>
            </div>

            <div className={Styles.btnContainer}>
              <button onClick={() => handleFileUpload()} className={Styles.btn}>
                Import
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
}
